import {useContext} from "react";
import {useQuery} from '@tanstack/react-query';
import UserContext from "@lib/contexts/userContext";
import {API_URLS, axiosRequest} from "@lib/axios";

/**
 * React Query wrapper for the Booth Topics query.
 */
const useBoothTopicsQuery = () => {
  const { authenticated } = useContext(UserContext);

  return useQuery({
    queryKey: ['boothTopics'],
    queryFn: async () => axiosRequest({
      method: 'GET',
      url: `${API_URLS.CURRICULA}/booth_topics`
    }),
    enabled: authenticated,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  });
};

export default useBoothTopicsQuery;
